import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getApi } from '../../../../utils/api'

export function useEmailAccount(activeAccount) {
  const [account, setAccount] = useState(EMPTY_OBJECT)

  useEffect(() => {
    if (activeAccount?.id) {
      getApi({
        endpoint: `api/mail-account/mail-integration/${activeAccount?.id}/info/`,
      }).then(resp => {
        setAccount(resp.data)
      })
    }
  }, [activeAccount?.id])

  return { account }
}
